import Netx from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import SavedSearchesCollection from '../savedSearches';

export const allSavedSearches = new SavedSearchesCollection([], {
	pager: {pageSize: 0x7fffffff},
});

allSavedSearches
	.on(
		'add',
		(model) =>
			model.isFavorite() && favoriteSavedSearches.add(model.attributes),
	)
	.on('destroy', (model) => favoriteSavedSearches.remove(model.id))
	.listenTo(dispatcher, 'search:save:success', (_, savedSearchBean) => {
		const model = allSavedSearches.get(savedSearchBean.id);
		if (!model) return;
		model.set({...savedSearchBean.attributes});
	});

export const favoriteSavedSearches = new SavedSearchesCollection([], {
	pager: {pageSize: 0x7fffffff, pagesToDisplay: 0},
	modeFilters: ['favorites'],
});

export default {allSavedSearches, favoriteSavedSearches};
